










































import axios from "axios";
import Vue, { PropType } from "vue";
import { TaskFile } from "src/views/taskFile/types";
import { TaskUserCommitsItem } from "@/api/types";
// import VueDraggableResizable from 'vue-draggable-resizable';
// import { getById } from '@/api';
import { generateComponentDetail, getById, getModelTree, strToInt32 } from "@/api";
import LeftMenu from "./task-model-view-left-menu.vue";
import rightInfo from "./task-model-view-right-info.vue";
// import toolBar from '../views/productDetail/ProductToolbar.vue';
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import ProductToolbar from "../views/productDetail/ProductToolbar.vue";

const apiUrl = process.env.VUE_APP_BORON;
const { spdengine } = window as any;
export default Vue.extend({
    components: { LeftMenu, rightInfo, ProductToolbar },
    props: {
        visible: Boolean,
        sessionId: String,
        file: {
            type: Object as PropType<TaskFile>
        },
        commit: { type: Object as PropType<TaskUserCommitsItem> },
        isDrawings: Boolean
    },
    data() {
        return {
            ref: {} as HTMLElement,
            apiUrl,
            benchId: 1,
            spdApi: null,
            spdParams: null,
            api: null,
            uuId: "",
            leftbuttonIsDisplay: true,
            rightbuttonIsDisplay: false,
            detailData: [] as { key: string; value: string }[],
            instanceName: "", // 构件名称
            modelTree: [],
            isDrawing: false,
            radian: 0,
            setParams: {},
            toolbarItem: {}
        };
    },
    watch: {
        visible: {
            async handler(val) {
                const res: any = await axios.get(
                    `${process.env.VUE_APP_ENGINEURL}/Boron/GetRadonPath?fileId=${this.file.uploadFile.fileId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${this.sessionId}`
                        }
                    }
                );

                const benchId = spdengine.Scott.create({
                    container: document.getElementById("ref"),
                    projectId: "sid",
                    dock: 4,
                    system: this.isDrawing
                        ? spdengine.SystemType.ST_2D_WSM
                        : spdengine.SystemType.ST_3D_WSM,
                    gisOptions: {},
                    useThreads: false,
                    tooBarState: false,
                    useWasmMemory: true,
                    engineSrcPath: "/static/",
                    envInitSuccessCB: () => {
                        this.benchId = benchId;
                        spdengine.Scott.run(this.benchId);
                        const api = spdengine.Apis.getApi(this.benchId);
                        const api3d = api["3D"];
                        // eslint-disable-next-line no-shadow

                        const params = api.PARAMS;
                        this.spdApi = api3d;
                        this.spdParams = params;
                        this.api = api;
                        // const benchMatrix = new spdengine.Matrix43D();
                        const pipeMatrix = new spdengine.Matrix43D().compose(
                            new spdengine.Vector33D(-100, -994, -1415),
                            new spdengine.Quaternion3D().setFromEuler(
                                new spdengine.Euler3D(0, 0, 0)
                            ),
                            new spdengine.Vector33D(1, 1, 1)
                        );
                        spdengine.Scott.load(this.benchId, {
                            url: `${this.apiUrl}/${res.filePath}/`, // .jdx模型所在后台路径地址
                            // url: './modules/ZYY-塔楼-AR/',
                            sessionId: this.sessionId,
                            workerUrl: "", // 加载模型worker代码所在地址，为了提升模型加载速率，spdengine拉取数据时启用多个worker（pc10个，移动端5个），多线程加载数据，有效加快加载速度
                            orgModelId: 1, // 原始model ID，原始model id 考虑到模型复用问题
                            newModelId: 1, // 该模型在该项目中的ID号，orgModelId对应的是模型的固有id号，而该id是在该视图中的唯一标识符
                            modelMatrix: pipeMatrix // 模型在该视图中的变化矩阵
                        });
                        api.PARAMS.eg_enableOutline = true;
                        api.PARAMS.sr_enable = true;
                        api.PARAMS.rd_continue = true;
                        api.PARAMS.eg_mutipleSamples = 8;
                        api.PARAMS.eg_maxLevel = 3;
                        api.PARAMS.hl_highlightoutlineColor = 0xffff00ff;
                        api.PARAMS.hl_enableClick = true; // 开启左键点击
                        api.PARAMS.bc_rightMuneEnable = true; // 开启右键菜单
                        api.PARAMS.wd_gravityEnable = false;
                        api.PARAMS.wd_collisionEnable = false;
                        api.PARAMS.wd_moveSpeed = 10; // 设置漫游速度
                        api.PARAMS.wd_moveVerticalSpeed = 10;

                        const timer = setTimeout(() => {
                            this.setbg(api3d);
                            clearTimeout(timer);
                        }, 50);
                        this.detailData = [];
                        this.instanceName = "";
                        api3d.addSelectEventListener("click", async e => {
                            if (e.uuids.length === 0) return;
                            const uuid = strToInt32(e.uuids[0]);
                            // eslint-disable-next-line no-shadow

                            // eslint-disable-next-line no-shadow
                            const res: any = await getById(
                                { fileId: this.file.uploadFile.fileId, instanceId: uuid },
                                this.sessionId
                            );
                            if (res.status.error === 0) {
                                const componentDetails = generateComponentDetail(
                                    res.instanceProperty.propertySets
                                );
                                this.detailData = componentDetails;
                                this.instanceName = res.instanceProperty.name;
                                this.rightbuttonIsDisplay = true;
                            }
                        });
                    }
                });
                console.log(this.file);

                const treeRes: any = await getModelTree(
                    { fileId: this.file.uploadFile.fileId },
                    this.sessionId
                );
                if (treeRes.status.error === 0) {
                    let i = 0;
                    const addKey = arr =>
                        arr.map(item => ({
                            ...item,
                            // eslint-disable-next-line no-plusplus
                            key: i++,
                            children: "children" in item ? addKey(item.children) : undefined
                        }));
                    this.modelTree = addKey(treeRes.modelLevelTree.children);
                } else {
                    this.$message.error(treeRes?.status?.errorDesc);
                }
            },
            immediate: true
        }
    },
    methods: {
        handleClick() {
            console.log(this.benchId);
            spdengine.Apis.getApi(this.benchId)["3D"].hiddenComponent("6");
            console.log(spdengine.Apis.getApi(this.benchId)["3D"]);
        },
        modelclick(benchId, api3d) {
            api3d.addSelectEventListener("click", result => {
                console.log("点击模型构件");
                console.log(result);
                console.log(this.file);
                const uid = spdengine.btoa(result.uuids[0]);
                console.log(uid);

                this.uuId = encodeURIComponent(uid);
                console.log(this.uuId);
                //  const res = apis.getById(this.file.uploadFile.modelGroupId, this.uuId);
                //  if (!apis.error(res)) {
                //    console.log(res);
                //  }
            });
        },
        setbg(api3d: any) {
            const cfgLinearGradient = [
                { stop: 0, color: "#23313E" },
                { stop: 1, color: "#0F1014" }
            ];
            const width = 1920;
            const height = 1080;
            const canvas = document.createElement("canvas");
            canvas.setAttribute("width", width.toString());
            canvas.setAttribute("height", height.toString());
            const ctx: any = canvas.getContext("2d");
            const grad = ctx.createRadialGradient(
                width / 2,
                height / 2,
                5,
                width / 2,
                height / 2,
                800
            );
            // eslint-disable-next-line no-restricted-syntax
            for (const item of cfgLinearGradient) {
                grad.addColorStop(item.stop, item.color);
            }
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, width, height);
            const data = ctx.getImageData(0, 0, width, height);
            // debugger;
            console.log(data);

            api3d.setBackgroundImageData(data.data, data.width, data.height);
            // return data;
        },
        together(item) {
            this.toolbarItem = item;
        },
        set(val) {
            this.setParams = val;
        },
        setRadian(val) {
            this.radian = val;
        }
    }
});
